import { service } from '../../helpers/http'

export default {
  actions: {
    ActionTimetableRulesIndex: ({ commit }, payload) => {
      const p = { ...(payload || {}) }
      if (p.search != null && String(p.search).trim() !== '') {
        p.q = p.search
      }
      delete p.search
      delete p.column_order
      delete p.direction

      return service({
        module: 'timetableRules',
        action: 'index',
        payload: p,
      })
    },

    ActionTimetableRulesDuplicate: ({ commit }, payload) =>
      service({
        module: 'timetableRules',
        action: 'duplicate',
        params: { id: payload.id },
        payload: {},
      }),

    ActionTimetableRulesToggle: ({ commit }, payload) => {
      const body = {}
      if (Object.prototype.hasOwnProperty.call(payload || {}, 'active')) {
        body.active = payload.active
      }
      return service({
        module: 'timetableRules',
        action: 'toggle',
        params: { id: payload.id },
        payload: body,
      })
    },

    ActionTimetableRulesDestroy: ({ commit }, payload) =>
      service({
        module: 'timetableRules',
        action: 'destroy',
        params: { id: payload.id },
        payload: {},
      }),

    ActionTimetableRulesShow: ({ commit }, payload) =>
      service({
        module: 'timetableRules',
        action: 'show',
        params: { id: payload.id },
        payload: {},
      }),

    ActionTimetableRulesStore: ({ commit }, payload) =>
      service({
        module: 'timetableRules',
        action: 'store',
        payload,
      }),

    ActionTimetableRulesUpdate: ({ commit }, payload) =>
      service({
        module: 'timetableRules',
        action: 'update',
        params: { id: payload.id },
        payload,
      }),
  },
  namespaced: true,
}
